// frontend/src/store/undoStore.ts
// Brighella v2 (ADR-014 D12) — Last-revision register for the universal
// undo toast + Cmd+Z shortcut.
//
// Mutations that return `_revision: { id, reversible_until }` call
// pushRevision({...}) on success. The UndoToast component watches this
// store and renders an undo CTA for the window. Cmd+Z hits popLatest()
// and POSTs /api/revisions/:id/undo. Once reverted, the entry clears.
//
// Not persisted — undo is session-scoped by intent (you should only undo
// something you just did; a refresh is a natural commit).

import { create } from 'zustand'

export interface UndoRevision {
  id: number
  reversible_until: string       // ISO timestamp from the API
  entity_type: string
  entity_id: number
  /** Optional human label for the toast ("performance #42 deleted"). */
  label?: string
}

export interface UndoState {
  latest: UndoRevision | null
  pushRevision: (rev: UndoRevision) => void
  clear: () => void
  /** Returns the latest revision and clears it from state. */
  popLatest: () => UndoRevision | null
}

export const useUndoStore = create<UndoState>((set, get) => ({
  latest: null,

  pushRevision: (rev) => set({ latest: rev }),

  clear: () => set({ latest: null }),

  popLatest: () => {
    const cur = get().latest
    if (cur) set({ latest: null })
    return cur
  },
}))

/** Test helper. */
export function _resetUndoStoreForTests(): void {
  useUndoStore.setState({ latest: null })
}
